import * as React from "react";
import { YODHA_COLORS } from "../constants/colours";

interface SquareButtonWithTextProps {
  imgSrc: string;
  text: string;
  active: boolean;
  onClick: React.MouseEventHandler<HTMLDivElement>;
}

const SquareButtonWithText = ({
  imgSrc,
  text,
  active,
  onClick,
}: SquareButtonWithTextProps) => {
  return (
    <div
      onClick={onClick}
      style={{ background: active ? "#fff" : YODHA_COLORS.grey }}
      className="flex flex-col items-center content-center p-2 mr-2 rounded-md border-4 cursor-pointer"
    >
      <img src={imgSrc} className="h-6 w-8" />
      <p className="font-serif font-semibold" style={{ fontSize: 8 }}>
        {text}
      </p>
    </div>
  );
};

export default SquareButtonWithText;
